<template>
  <div class="account-login-box">
    <div class="form-box">
      <el-form ref="form" :model="dataModel" label-width="0" :rules="rules" autocomplete="false">
        <el-form-item label="" prop="mobile_phone" :required="false">
          <el-input v-model.trim="dataModel.mobile_phone" :maxlength="11" autofocus @keyup.enter.native="formSubmit" placeholder="输入手机号码"></el-input>
        </el-form-item>

        <el-form-item label="" prop="code">
          <el-row :gutter="12">
            <el-col :span="15">
              <el-input v-model.trim="dataModel.code" :maxlength="4" @keyup.enter.native="formSubmit" placeholder="输入短信中的验证码"></el-input>
            </el-col>
            <el-col :span="9">
              <el-button :disabled="!phoneIsPass || verifyCodeInfo.time > 0" class="send-code-btn" :class="{small: verifyCodeInfo.time > 0}" @click="sendVerifyCode">
                {{verifyCodeInfo.time > 0 ? `重新获取(${verifyCodeInfo.time}s)` : '获取验证码'}}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="" prop="passwd">
          <el-input type="text" v-model.trim="dataModel.passwd" :maxlength="20" @keyup.enter.native="formSubmit" placeholder="输入6-20位新密码"></el-input>
        </el-form-item>

        <el-form-item label="" prop="checkPasswd">
          <el-input type="text" v-model.trim="dataModel.checkPasswd" :maxlength="20" @keyup.enter.native="formSubmit" placeholder="输入确认密码"></el-input>
        </el-form-item>

        <el-button class="login-btn" type="primary" @click="formSubmit">重置</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import md5 from 'md5';
import utils from '@/libs/utils';
import Http from '@/libs/http';

export default {
  name: 'forget-password',
  components: {
  },
  data() {
    const validateCheckPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.dataModel.passwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dataModel: {
        mobile_phone: '',
        code: '',
        passwd: '',
        checkPasswd: '',
      },
      rules: {
        mobile_phone: [
          { required: true, trigger: 'blur', message: '请输入账号' },
          { pattern: /^1\d{10}$/, trigger: 'blur', message: '请输入正确的账号' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{4}$/, trigger: 'blur', message: '请输入正确的验证码' },
        ],
        passwd: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { min: 6, trigger: 'blur', message: '请输入正确的密码' },
        ],
        checkPasswd: [
          { validator: validateCheckPassword, trigger: 'blur' },
        ],
      },
      verifyCodeInfo: {
        time: 0,
      },
    };
  },
  computed: {
    phoneIsPass() {
      if (this.dataModel.mobile_phone) {
        return /^1\d{10}$/.test(this.dataModel.mobile_phone);
      }
      return false;
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    sendVerifyCode() {
      Http.post('/sys/sys_verify_code_get', {
        mobile_phone: this.dataModel.mobile_phone,
        action: 1,
      }, { noToast: true }).then(() => {
        this.verifyCodeInfo.time = 60;
        this.timer = setInterval(() => {
          this.verifyCodeInfo.time -= 1;
          if (this.verifyCodeInfo.time <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      }).catch((err) => {
        this.verifyCodeInfo.time = 0;

        if (err.ret === -2) {
          return utils.msgbox.confirm('该手机号尚未开通同业账号，是否开通？', '账号未开通', {
            confirmButtonText: '立即开通',
            cancelButtonText: '　取消　',
            type: 'warning',
          }).then(() => {
            // 跳转到注册前，先返回账号密码登录页，这样注册页返回才能正确
            this.$emit('change-page', 2);
            this.$emit('change-page', 5);
          }).catch((e) => {
            if (e) console.log(e);
          });
        }

        utils.msg.error(err.msg);
      });
    },
    formSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const postData = {
            mobile_phone: this.dataModel.mobile_phone,
            passwd: md5(this.dataModel.passwd),
            code: this.dataModel.code,
          };
          Http.post('/sys/peer_passwd_reset', postData).then(() => {
            utils.msg.success('修改成功');
            this.$emit('change-page', 2);
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>

.account-login-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #2F333D;
  font-size: 14px;
  line-height: 1;
  .form-box{
    width: 100%;
    /deep/ .el-form-item{
      margin-bottom: 20px;
      .el-input__inner{
        height: 48px;
        color: #2F333D;
        font-size: 16px;
        border-radius:2px;
      }
    }
    .send-code-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      border-radius:2px;
      border:1px solid #599FFF;
      color: #599FFF;
      &:disabled{
        border: 1px solid #E9EEF2;
        color: #91999F;
        background: #fff;
      }
      &.small{
        font-size: 14px;
      }
    }
    .login-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      background: #599FFF;
      border-radius:2px;
      &:hover{
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/components/forget-password.vue